import { createApp } from 'vue/dist/vue.esm-bundler';
import Announcement from './Announcement.vue';


const mountEl = document.querySelector('[data-app-announcement-form]');

if ( mountEl )
{
    createApp(Announcement, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}